export const STATUS_CONFIG = {
  ready: {
    label: "未受付",
    color: "#C2C8B9",
    rowColor: "#DCDFD4",
    rowHover: "#CED3C6",
  },
  checked: {
    label: "受付済み",
    color: "#C2C8CF",
    rowColor: "#DEE0E5",
    rowHover: "#D0D4DA",
  },
  late: {
    label: "遅れ",
    color: "#CECCBE",
    rowColor: "#E4E4D9",
    rowHover: "#DAD8CA",
  },
};

export function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] ?? {
    label: "参加イベントか日付が違う可能性があります",
    color: "#CF000E",
  };

  return (
    <span style={{
      display: "inline-block",
      padding: "4px 8px",
      borderRadius: 12,
      fontSize: 12,
      color: "#000000",
      background: config.color,
    }}>
      {config.label}
    </span>
  );
}